import createVueComponent from '../createVueComponent';

const ArrowBigUp = createVueComponent('ArrowBigUpIcon', [
  ['path', { d: 'M9 21V10H5l7-7 7 7h-4v11z' }],
]);

export default ArrowBigUp;
